import Vue from 'vue';
import { mapPathAndBreadcrumbLabels } from '@constants/navigation';

const state = () => ({
    currentService: null,
    breadCrumb: [],
    subServices: {},
    services: {
        passAccount: {
            url: '/accMgmt',
            name: 'navigations.accountManagementTitle',
            text: 'navigations.textForAccountManagement',
            routes: [
                {
                    name: 'Account management',
                    url: '/accMgmt'
                }
            ]
        }
        // administration: {
        //     url: '/administration',
        //     name: 'navigations.adminTitle',
        //     text: 'navigations.textForAdministration',
        //     routes: [
        //         {
        //             name: 'Administration',
        //             url: '/administration'
        //         }
        //     ]
        // }
    },
    currentLang: navigator?.language.toLowerCase().includes('fr') ? 'fr' : 'en',
    anonymous: false
});

const getters = {
    getAnonymous: state => {
        return state.anonymous;
    },
    getCurrentLang: state => {
        return state.currentLang;
    },
    getServices: state => {
        return state.services;
    },
    getCurrentService: state => {
        if (state.currentService) {
            return state.currentService;
        }
        return null;
    },
    getServiceByPath: state => path => {
        for (const key in state.services) {
            const service = state.services[key];
            if (service.url === path) {
                return service;
            }
        }
        return null;
    },
    getSubServices: state => currentService => {
        if (currentService) {
            return state.subServices[currentService.id];
        }
        return state.subServices['serviceMgmt'];
    }
};

const mutations = {
    setBreadCrumb(state, path) {
        if (path) {
            const pathTab = path.split('/').filter(p => p && p.length > 0);
            const breadCrumb = [];
            let url = '/';

            for (const element of pathTab) {
                const label = mapPathAndBreadcrumbLabels[element];

                url += `${element}/`;
                breadCrumb.push({ label, url });
            }
            state.breadCrumb = breadCrumb;
        }
    },
    resetService(state) {
        Vue.set(state, 'currentService', null);
    },
    setCurrentService(state, service) {
        Vue.set(state, 'currentService', service);
    },
    selectLang(state, currentLang) {
        state.currentLang = currentLang;
    },
    setAnonymous(state, value) {
        state.anonymous = value;
    }
};

const actions = {
    callRouteChanged({ commit, rootGetters }, { path }) {
        const currentService = rootGetters['navigation/getServiceByPath'](path);

        commit('setCurrentService', currentService);
        commit('setBreadCrumb', path);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
